/**
 * Opens the CounterCool demo video in a lightGallery overlay.
 *
 * lightGallery is the vendored gallery library in `assets/lightgallery.js`, and
 * lgVideo is its video plugin in `assets/lg-video.js`. Both load in the head of
 * `layout/theme.liquid` with `defer`, and this file loads with `defer` after
 * them in `sections/countercool-how-it-works.liquid`, which runs them in
 * document order, so their globals exist by the time this file runs.
 * https://www.lightgalleryjs.com/docs/settings/#video-plugin
 *
 * Dynamic mode takes the slide from an array instead of from a link. It suits a
 * button trigger, and lightGallery reads a video slide only when the item has
 * no `src`. https://www.lightgalleryjs.com/docs/dynamic-variables/
 */
(function () {
  const buttons = document.querySelectorAll('[aura-countercool-demo-video]');

  // Do not proceed if no button asks for the video. The section renders the
  // trigger only when a video is set.
  if (!buttons.length) {
    return;
  }

  /**
   * Reads the video slide a button carries in its data attributes.
   *
   * @param {HTMLElement} button The trigger the section rendered.
   * @returns {Object|null} A lightGallery slide, or null when the sources are unusable.
   */
  const readSlide = (button) => {
    let sources = [];

    // A malformed string would throw and stop every later button.
    try {
      sources = JSON.parse(button.dataset.sources);
    } catch (error) {
      return null;
    }

    if (!Array.isArray(sources) || !sources.length) {
      return null;
    }

    return {
      video: {
        source: sources,
        attributes: { controls: true, preload: 'metadata', playsinline: true },
      },
      poster: button.dataset.poster || '',
      subHtml: button.dataset.title || '',
    };
  };

  Array.from(buttons).forEach((button) => {
    // Do not proceed if this button already has a gallery. The theme editor
    // re-runs this file on any section reload, and a second gallery would open
    // two overlays on one click.
    if (button.dataset.galleryReady) {
      return;
    }

    const slide = readSlide(button);

    // Do not proceed without a playable source. The button then does nothing
    // rather than opening an empty overlay.
    if (!slide) {
      return;
    }

    const gallery = lightGallery(button, {
      dynamic: true,
      dynamicEl: [slide],
      plugins: [lgVideo],
      speed: 400,
      download: false,
      counter: false,
      autoplayFirstVideo: true,
    });

    button.addEventListener('click', () => {
      gallery.openGallery(0);
    });

    button.dataset.galleryReady = 'true';
  });
})();
